import { IconStorage } from "@app/shared/icons/interfaces";

export const linkV4: IconStorage = {
  svgCode: () => ([
    "M7.5 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H9C11.7614 17 14 14.7614 14 12M16.5 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15C12.2386 7 10 9.23858 10 12",
  ]),
};
